import React from 'react';
import { IconBaseProps, IconType } from 'react-icons';

interface IconProps {
  Icon: IconType;
}

// exemplo de uso: <ReactIcon Icon={FaReact} /> OBS : PRECISA IMPORTAR O ÍCONE DA BIBLIOTECA ONDE VAI USAR
const ReactIcon: React.FC<IconProps & IconBaseProps> = ({ Icon, ...rest }) => {
  return <Icon {...rest} />;
};

export default ReactIcon;
